import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const MusicIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('MusicIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.303 11.888c-.207-.45-1.053-1.107-1.264-1.202a2.6 2.6 0 0 0-1.592-.306 2.56 2.56 0 0 0-1.457.695c-.393.38-.646.876-.718 1.41a2.38 2.38 0 0 0 .316 1.542c.278.466.707.83 1.221 1.037a2.6 2.6 0 0 0 1.62.103 2.53 2.53 0 0 0 1.351-.873c.339-.428.523-.95.523-1.49V4.456a1 1 0 0 1 .78-.975l7.667-1.73v9.31m0 0v.917c0 .538-.184 1.061-.522 1.488a2.53 2.53 0 0 1-1.35.874 2.6 2.6 0 0 1-1.621-.104 2.5 2.5 0 0 1-1.221-1.036 2.38 2.38 0 0 1-.317-1.542c.073-.534.325-1.03.718-1.41.394-.381.906-.625 1.457-.696a2.6 2.6 0 0 1 1.593.307c.21.095 1.056.752 1.263 1.201"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
MusicIcon.id = 'MusicIcon';
MusicIcon.displayName = 'MusicIcon';
export default MusicIcon;
